<template>
  <base-filter-expander :title="$t('search.fuel-type')" :is-valid="isValid">
    <base-tiles-grid icon-grid>
      <base-tile
        v-for="option in options"
        :id="option.id"
        :key="option.id"
        :image="option.image"
        :text="option.text"
        :is-active="fuelTypeIsActive(option.id)"
        type="icon"
        text-align="center"
        @store-update="updateStore($event)"
      />
    </base-tiles-grid>
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import BaseTilesGrid from "@/components/ui/BaseTilesGrid/BaseTilesGrid.vue";
import BaseTile from "@/components/ui/BaseTile/BaseTile.vue";
import fuelTypes from "@/constants/fuelTypes";
import { ADD_FUEL_TYPE, REMOVE_FUEL_TYPE } from "@/store/mutationTypes";
import { GET_DATA_FROM_API } from "@/store/actionTypes";

export default {
  name: "FuelTypeSelect",
  components: {
    BaseFilterExpander,
    BaseTilesGrid,
    BaseTile
  },
  computed: {
    options() {
      return fuelTypes;
    },
    isValid() {
      return this.$store.state.search.fuelType.length > 0;
    }
  },
  methods: {
    updateStore(option) {
      const action = option.action === "add" ? ADD_FUEL_TYPE : REMOVE_FUEL_TYPE;
      this.$store.commit(action, option.id);
      this.$store.dispatch(GET_DATA_FROM_API);
    },
    fuelTypeIsActive(fuelType) {
      return this.$store.state.search.fuelType.includes(fuelType);
    }
  }
};
</script>
